import { render, staticRenderFns } from "./VQDate.vue?vue&type=template&id=d2d96968&"
import script from "./VQDate.vue?vue&type=script&lang=js&"
export * from "./VQDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports